import { IconType } from "react-icons";
import { BiWorld, BiBuildingHouse, BiBoltCircle } from "react-icons/bi";
import { FaShip, FaFish, FaLeaf, FaSeedling, FaTools, FaIndustry, FaCar, FaRecycle, FaWind, FaFire, FaTree, FaWater } from "react-icons/fa";
import { GiWheat, GiBirdTwitter, GiHand, GiEarthAmerica, GiFarmTractor, GiFactory, GiTreeBranch, GiWaterDrop, GiSolarPower, GiTruck, GiOilDrum, GiMountainCave } from "react-icons/gi";
const availableIcons: { name: string; icon: IconType; iconName: string }[] = [
  { name: "Blé", icon: GiWheat, iconName: "GiWheat" },
  { name: "Oiseau", icon: GiBirdTwitter, iconName: "GiBirdTwitter" },
  { name: "Poisson", icon: FaFish, iconName: "FaFish" },
  { name: "Main", icon: GiHand, iconName: "GiHand" },
  { name: "Terre", icon: GiEarthAmerica, iconName: "GiEarthAmerica" },
  { name: "Tracteur", icon: GiFarmTractor, iconName: "GiFarmTractor" },
  { name: "Feuille", icon: FaLeaf, iconName: "FaLeaf" },
  { name: "Plant", icon: FaSeedling, iconName: "FaSeedling" },
  { name: "Arbre", icon: FaTree, iconName: "FaTree" },
  { name: "Usine", icon: FaIndustry, iconName: "FaIndustry" },
  { name: "Énergie solaire", icon: GiSolarPower, iconName: "GiSolarPower" },
  { name: "Vent", icon: FaWind, iconName: "FaWind" },
  { name: "Feu", icon: FaFire, iconName: "FaFire" },
  { name: "Camion", icon: GiTruck, iconName: "GiTruck" },
  { name: "Voiture", icon: FaCar, iconName: "FaCar" },
  { name: "Bateau", icon: FaShip, iconName: "FaShip" },
  { name: "Bâtiment", icon: BiBuildingHouse, iconName: "BiBuildingHouse" },
  { name: "Recyclage", icon: FaRecycle, iconName: "FaRecycle" },
  { name: "Eau", icon: FaWater, iconName: "FaWater" },
  { name: "Goutte d’eau", icon: GiWaterDrop, iconName: "GiWaterDrop" },
  { name: "Industrie lourde", icon: GiFactory, iconName: "GiFactory" },
  { name: "Pétrole", icon: GiOilDrum, iconName: "GiOilDrum" },
  { name: "Mine", icon: GiMountainCave, iconName: "GiMountainCave" },
  { name: "Monde", icon: BiWorld, iconName: "BiWorld" },
  { name: "Électricité", icon: BiBoltCircle, iconName: "BiBoltCircle" },
  { name: "Outil", icon: FaTools, iconName: "FaTools" },
  { name: "Branche", icon: GiTreeBranch, iconName: "GiTreeBranch" },
];
export { availableIcons };

